<div class="container-fluid glb-popup" style="max-width: 800px ;">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>
        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="fullName" id="fullName" type="text" pInputText>
            <label for="fullName">Full Name</label>
            @for (validation of validationMessages.fullName; track validation) {
              <span>
                @if (form1.get('fullName').hasError(validation.type) && (form1.get('fullName').dirty || form1.get('fullName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6"></div>
        <div class="col-lg-2">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown [options]="titles" formControlName="title" optionLabel="name" optionValue="value"
            [filter]="true" filterBy="value" [showClear]="false" placeholder="Title"></p-dropdown>
            <label for="title">Title</label>
            @for (validation of validationMessages.title; track validation) {
              <span>
                @if (form1.get('title').hasError(validation.type) && (form1.get('title').dirty || form1.get('title').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-3">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="firstName" id="firstName" type="text" pInputText>
            <label for="firstName">First Name</label>
            @for (validation of validationMessages.firstName; track validation) {
              <span>
                @if (form1.get('firstName').hasError(validation.type) && (form1.get('firstName').dirty || form1.get('firstName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-3">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="lastName" id="lastName" type="text" pInputText>
            <label for="lastName">Last Name</label>
            @for (validation of validationMessages.lastName; track validation) {
              <span>
                @if (form1.get('lastName').hasError(validation.type) && (form1.get('lastName').dirty || form1.get('lastName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-4">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="suffix" id="suffix" type="text" pInputText>
            <label for="suffix">Suffix</label>
            @for (validation of validationMessages.suffix; track validation) {
              <span>
                @if (form1.get('suffix').hasError(validation.type) && (form1.get('suffix').dirty || form1.get('suffix').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="mailAdrCompanyName" id="mailAdrCompanyName" type="text" pInputText>
            <label for="mailAdrCompanyName">Company Name</label>
            @for (validation of validationMessages.mailAdrCompanyName; track validation) {
              <span>
                @if (form1.get('mailAdrCompanyName').hasError(validation.type) && (form1.get('mailAdrCompanyName').dirty || form1.get('mailAdrCompanyName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="emailAddress" id="emailAddress" type="email" pInputText>
            <label for="emailAddress">Email Address</label>
            @for (validation of validationMessages.emailAddress; track validation) {
              <span>
                @if (form1.get('emailAddress').hasError(validation.type) && (form1.get('emailAddress').dirty || form1.get('emailAddress').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6"></div>

        <div class="col-lg-3">
          <span class="p-float-label w-100 mb-3">
            <!-- <p-inputMask formControlName="mailAdrPhone" id="mailAdrPhone" mask="(999) 999-9999" type="text">
          </p-inputMask> -->
          <input formControlName="mailAdrPhone" id="mailAdrPhone" type="text" pInputText>
          <label for="mailAdrPhone">Published Phone</label>
          @for (validation of validationMessages.mailAdrPhone; track validation) {
            <span>
              @if (form1.get('mailAdrPhone').hasError(validation.type) && (form1.get('mailAdrPhone').dirty || form1.get('mailAdrPhone').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>



      <div class="col-lg-3">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="mobilePhone" id="mobilePhone" type="number" pInputText>
          <label for="mobilePhone">Mobile Phone</label>
          @for (validation of validationMessages.mobilePhone; track validation) {
            <span>
              @if (form1.get('mobilePhone').hasError(validation.type) && (form1.get('mobilePhone').dirty || form1.get('mobilePhone').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <div class="col-lg-3">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="phone2" id="phone2" type="number" pInputText>
          <label for="phone2">Mobile Phone</label>
          @for (validation of validationMessages.phone2; track validation) {
            <span>
              @if (form1.get('phone2').hasError(validation.type) && (form1.get('phone2').dirty || form1.get('phone2').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <div class="col-lg-3">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="referralSrc" id="referralSrc" type="text" pInputText>
          <label for="referralSrc">Referral Source</label>
          @for (validation of validationMessages.referralSrc; track validation) {
            <span>
              @if (form1.get('referralSrc').hasError(validation.type) && (form1.get('referralSrc').dirty || form1.get('referralSrc').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-3">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="referralSrcId" id="referralSrcId" type="number" pInputText>
          <label for="referralSrcId">Referral Source Id</label>
          @for (validation of validationMessages.referralSrcId; track validation) {
            <span>
              @if (form1.get('referralSrcId').hasError(validation.type) && (form1.get('referralSrcId').dirty || form1.get('referralSrcId').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-3">
        <span class="p-float-label w-100 mb-3">
          <!-- <p-inputMask formControlName="mailAdrFax" id="mailAdrFax" mask="(999) 999-9999" type="text">
        </p-inputMask> -->
        <input formControlName="mailAdrFax" id="mailAdrFax" type="text" pInputText>
        <label for="mailAdrFax">Fax</label>
        @for (validation of validationMessages.mailAdrFax; track validation) {
          <span>
            @if (form1.get('mailAdrFax').hasError(validation.type) && (form1.get('mailAdrFax').dirty || form1.get('mailAdrFax').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
    <div class="col-lg-12">
      <span class="p-float-label w-100 mb-3">
        <input formControlName="mailAdrStreet" id="mailAdrStreet" type="text" pInputText>
        <label for="mailAdrStreet">Street</label>
        @for (validation of validationMessages.mailAdrStreet; track validation) {
          <span>
            @if (form1.get('mailAdrStreet').hasError(validation.type) && (form1.get('mailAdrStreet').dirty || form1.get('mailAdrStreet').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>


    <div class="col-lg-12">
      <span class="p-float-label w-100 mb-3">
        <input formControlName="mailAdrStreet2" id="mailAdrStreet2" type="text" pInputText>
        <label for="mailAdrStreet2">Street2</label>
        @for (validation of validationMessages.mailAdrStreet2; track validation) {
          <span>
            @if (form1.get('mailAdrStreet2').hasError(validation.type) && (form1.get('mailAdrStreet2').dirty || form1.get('mailAdrStreet2').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-5">
      <span class="p-float-label w-100 mb-3">
        <input formControlName="mailAdrCity" id="mailAdrCity" type="text" pInputText>
        <label for="mailAdrCity">City</label>
        @for (validation of validationMessages.mailAdrCity; track validation) {
          <span>
            @if (form1.get('mailAdrCity').hasError(validation.type) && (form1.get('mailAdrCity').dirty || form1.get('mailAdrCity').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-2">
      <span class="p-float-label w-100 mb-3">
        <p-dropdown [options]="states" formControlName="mailAdrState" optionLabel="name" appendTo="body"
          optionValue="abbr" [filter]="true" filterBy="name" [showClear]="false" placeholder="State">
        </p-dropdown>
        <label for="State">State</label>
        @for (validation of validationMessages.mailAdrState; track validation) {
          <span>
            @if (form1.get('mailAdrState').hasError(validation.type) && (form1.get('mailAdrState').dirty || form1.get('mailAdrState').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-2">
      <span class="p-float-label w-100 mb-3">
        <input formControlName="mailAdrPostalCode" id="mailAdrPostalCode" type="text" pInputText>
        <label for="mailAdrPostalCode">Postal Code</label>
        @for (validation of validationMessages.mailAdrPostalCode; track validation) {
          <span>
            @if (form1.get('mailAdrPostalCode').hasError(validation.type) && (form1.get('mailAdrPostalCode').dirty || form1.get('mailAdrPostalCode').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-3">
      <span class="p-float-label w-100 mb-3">
        <p-dropdown [options]="countries" formControlName="mailAdrCountry" optionLabel="name"
          appendTo="body" optionValue="abbr" [filter]="true" filterBy="name" [showClear]="false"
          placeholder="Country">
        </p-dropdown>
        <label for="Country">Country</label>
        @for (validation of validationMessages.mailAdrCountry; track validation) {
          <span>
            @if (form1.get('mailAdrCountry').hasError(validation.type) && (form1.get('mailAdrCountry').dirty || form1.get('mailAdrCountry').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
    <div class="col-lg-12">
      <span class="p-float-label w-100 mb-3">
        <textarea formControlName="opsNotes" id="opsNotes" [rows]="2" pInputTextarea></textarea>
        <label for="opsNotes">Optional Notes</label>
        @for (validation of validationMessages.opsNotes; track validation) {
          <span>
            @if (form1.get('opsNotes').hasError(validation.type) && (form1.get('opsNotes').dirty || form1.get('opsNotes').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    @if (contactId) {
      <hr>
      }
      @if (contactId) {
        <div class="col-lg-6">
          <app-tag-join-select
            [tagSource]="80" [tagSourceId]="contactId" tagType="4" >
          </app-tag-join-select>
        </div>
      }
    </div>
  </div>

  <hr>
    <div class="row m-0">
      <div class="col-lg-12">
        <div class="btn-group">
          <div class="button-group">
            @if (contactId) {
              <button pButton class="btn-delete p-button-outlined p-button-danger"
              (click)="onFormDelete()">Delete</button>
            }
          </div>

          <div class="button-group">
            <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Close</button>
            @if (!contactId) {
              <button pButton class="btn-addt p-button" (click)="formAdd()">Add</button>
            }
            @if (contactId) {
              <button pButton class="btn-upt p-button" (click)="formUpdate()">Update</button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
